import { render } from "./case.vue?vue&type=template&id=4de26a5b"
import script from "./case.vue?vue&type=script&lang=ts"
export * from "./case.vue?vue&type=script&lang=ts"

import "./case.vue?vue&type=style&index=0&id=4de26a5b&lang=css"
script.render = render

export default script